import { render, staticRenderFns } from "./LiffUISetting.vue?vue&type=template&id=e898176e&"
import script from "./LiffUISetting.vue?vue&type=script&lang=js&"
export * from "./LiffUISetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports